import { render, staticRenderFns } from "./DialogIntegrantesGabinete.vue?vue&type=template&id=7eef2f23&scoped=true&"
import script from "./DialogIntegrantesGabinete.vue?vue&type=script&lang=js&"
export * from "./DialogIntegrantesGabinete.vue?vue&type=script&lang=js&"
import style0 from "./DialogIntegrantesGabinete.vue?vue&type=style&index=0&id=7eef2f23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eef2f23",
  null
  
)

export default component.exports